class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resultsContainer = this.querySelector('[data-predictive-search]');
    this.popular = this.querySelector('.search-popular');
    if (!this.input) return;
    this.input.addEventListener('input', debounce(this.onChange.bind(this), 300));
    this.querySelectorAll('[type="reset"]').forEach((b) =>
      b.addEventListener('click', () => this.reset())
    );
  }

  onChange() {
    const term = this.input.value.trim();
    if (term.length < 2) {
      this.reset();
      return;
    }
    if (this.popular) this.popular.classList.add('hidden');
    fetch(
      `${window.routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=predictive-search&resources[limit]=6`
    )
      .then((response) => response.text())
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const results = parsed.querySelector('#shopify-section-predictive-search');
        if (results && this.resultsContainer) this.resultsContainer.innerHTML = results.innerHTML;
      })
      .catch(() => {});
  }

  reset() {
    if (this.resultsContainer) this.resultsContainer.innerHTML = '';
    if (this.popular) this.popular.classList.remove('hidden');
  }
}
customElements.define('predictive-search', PredictiveSearch);
